// extracted by mini-css-extract-plugin
export var activeTab = "tabs-module--activeTab--15a1d";
export var content = "tabs-module--content--44f11";
export var tab = "tabs-module--tab--d76a5";
export var tabs = "tabs-module--tabs--958c9";